import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiTarget, FiTrendingUp, FiLayers, FiActivity } = FiIcons;

const SOLUTIONS = [
  {
    title: 'Creative & Advertising Intelligence',
    problem: 'We do not know what competitors are doing effectively.',
    value: 'Systematic monitoring of competitor ads to identify winning creative patterns.',
    icon: FiTarget
  },
  {
    title: 'Campaign Strategy & Systems',
    problem: 'Our advertising lack a coherent strategic foundation.',
    value: 'Clarifying objective, audience, and creative hooks before production begins.',
    icon: FiLayers
  },
  {
    title: 'Digital Growth & UX',
    problem: 'Our website does not convert traffic into business value.',
    value: 'Strategy-led design and development focused on measurable business actions.',
    icon: FiTrendingUp
  },
  {
    title: 'Integrated Growth Partnership',
    problem: 'Our marketing activities are disconnected.',
    value: 'Connecting intelligence, strategy, and execution within one coherent system.',
    icon: FiActivity
  }
];

export default function Solutions() {
  return (
    <div className="bg-black pt-40 pb-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="max-w-4xl mb-32">
          <h1 className="text-6xl md:text-8xl font-serif font-bold mb-10 text-white leading-[1.1]">Start With the Business Challenge.</h1>
          <p className="text-2xl text-zinc-400 font-light leading-relaxed">Maxmark builds solutions around the results your organization needs to grow.</p>
        </motion.div>

        <div className="grid grid-cols-1 gap-12">
          {SOLUTIONS.map((sol, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="group p-12 md:p-20 bg-zinc-950 border border-zinc-900 rounded-[4rem] hover:border-blue-600 transition-all">
              <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
                <div className="lg:col-span-1">
                   <div className="w-16 h-16 rounded-2xl bg-blue-600/10 flex items-center justify-center text-blue-500">
                     <SafeIcon icon={sol.icon} className="w-8 h-8" />
                   </div>
                </div>
                <div className="lg:col-span-5">
                  <h3 className="text-[10px] font-bold uppercase tracking-[0.3em] text-zinc-600 mb-4">Business Problem</h3>
                  <p className="text-2xl font-serif font-bold text-white italic">"{sol.problem}"</p>
                </div>
                <div className="lg:col-span-6">
                  <h3 className="text-[10px] font-bold uppercase tracking-[0.3em] text-blue-500 mb-4">{sol.title}</h3>
                  <p className="text-xl text-zinc-400 leading-relaxed mb-10 font-light">{sol.value}</p>
                  <Link to="/contact" className="bg-white text-black px-10 py-4 rounded-xl font-bold uppercase tracking-widest text-[10px] hover:bg-blue-600 hover:text-white transition-all">Discuss Solution</Link>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}